import { Link } from "@tanstack/react-router"
import { Building2, Inbox } from "lucide-react"
import {
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
} from "@holigral/shared/ui/components/ui/sidebar"
import { useIsRouteActive } from "@holigral/shared/routing"
import { useT } from "@/i18n"

/**
 * Admin-area navigation (product.md §9.1): Submissions / Tenants. The
 * Account/Logout footer stays with the shared FooterMenu; there is no
 * workspace switcher in admin mode.
 */
export default function AdminNav() {
  const { t } = useT("admin")
  // Active state is a hook, so it cannot be resolved inside the map below.
  const isSubmissionsActive = useIsRouteActive({
    to: "/admin/submissions",
    fuzzy: true,
  })
  const isTenantsActive = useIsRouteActive({
    to: "/admin/tenants",
    fuzzy: true,
  })

  const items = [
    {
      to: "/admin/submissions",
      icon: <Inbox />,
      label: t("nav.submissions"),
      isActive: isSubmissionsActive,
    },
    {
      to: "/admin/tenants",
      icon: <Building2 />,
      label: t("nav.tenants"),
      isActive: isTenantsActive,
    },
  ] as const

  return (
    <SidebarMenu>
      {items.map(({ to, icon, label, isActive }) => (
        <SidebarMenuItem key={to}>
          <SidebarMenuButton
            isActive={isActive}
            render={
              <Link to={to}>
                {icon}
                {label}
              </Link>
            }
          />
        </SidebarMenuItem>
      ))}
    </SidebarMenu>
  )
}
